import React, { useState, useEffect, useRef } from "react";
import { format } from "date-fns";
import { object, bool } from "prop-types";

import FollowUs from "../follow-us";

import Authors from "../../../atoms/author";
import SocialMediaShare from "../../../molecules/social-media-share";

import "./author-and-timestamp.m.css";
import CommentsCount from "../../../atoms/comments-count";
import Share from "../../../atoms/other-icons/Share";
import useAdType from "../../../helper/useAdType";
import { AdContainer } from "../../../ads";

const AuthorAndTimeStamp = ({
  story,
  isDHExclusive,
  isSponsoredStory,
  isBrandspotNoAdStory,
  isBrandspotClientStory
}) => {
  const [showSharingOptions, setShowSharingOptions] = useState(false);
  const lastUpdatedDateAndTime = format(new Date(story && story["last-published-at"]), "dd MMMM yyyy, HH:mm");
  const shareRef = useRef(null);
  const [timestampShareWidth, setTimestampShareWidth] = useState("auto");
  const timestampShareRef = useRef(null);

  const [isMobile, setMobile] = useState(true);

  const adType = useAdType();

  const tempHideAd =
    story["story-template"] === "brandspot-with-no-ad" ||
    story?.slug?.includes("dhbrandspot-pr/best-crypto-casinos-2025-my-go-to-sites-for-bitcoin-gambling-3470705");

  useEffect(() => {
    if (window && window.innerWidth < 1024) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const authorWrapper = document.querySelector("#author-wrapper-id");
    const desktopHeader = document.querySelector("#desk-header");
    const authorId = document.querySelector("#author-resizer-wrapper");
    const primaryMenu = document.querySelector(".primary-menu");
    const stickyShare = document.querySelector("#sticky-div-id");
    const stickyShareTop = stickyShare?.getBoundingClientRect().top;

    let previousScrollY = window.scrollY;

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const authorWrapperBottom = authorWrapper?.getBoundingClientRect().bottom;
      const desktopHeaderBottom = desktopHeader?.getBoundingClientRect().bottom;
      const authorTop = authorId?.getBoundingClientRect().top;
      const primaryMenuBottom = primaryMenu?.getBoundingClientRect().bottom;

      if (typeof window !== "undefined") {
        const taboolaAdWrapper = document.querySelector("#ad-wrapper-taboola");
        const followUsCard = document.querySelector("#follow-us-card");

        if (followUsCard) {
          let followUsCardTop = followUsCard.getBoundingClientRect().top;
          followUsCardTop -= isMobile ? 10 : 80;

          const stickyShareHeight = stickyShare?.getBoundingClientRect().height || 0;

          if (followUsCardTop <= stickyShareHeight) {
            setIsSticky(false);
            previousScrollY = currentScrollY;
            return;
          }
        }

        if (taboolaAdWrapper) {
          let taboolaAdTop = taboolaAdWrapper.getBoundingClientRect().top;
          taboolaAdTop -= isMobile ? 20 : 70;

          const stickyShareHeight = stickyShare?.getBoundingClientRect().height || 0;

          if (taboolaAdTop <= stickyShareHeight) {
            setIsSticky(false);
            previousScrollY = currentScrollY;
            return;
          }
        }

        if (isMobile) {
          if (currentScrollY >= stickyShareTop) {
            stickyShare.style.top = primaryMenuBottom - 12 + "px";
            setIsSticky(true);
          } else {
            if (currentScrollY < previousScrollY && currentScrollY <= stickyShareTop - 35) {
              setIsSticky(false);
            }
          }
        } else {
          if (isSponsoredStory || isBrandspotNoAdStory || isBrandspotClientStory) {
            desktopHeaderBottom >= authorTop + 10 ? setIsSticky(true) : setIsSticky(false);
          } else {
            desktopHeaderBottom >= authorWrapperBottom + 10 ? setIsSticky(true) : setIsSticky(false);
          }
        }
      }
      previousScrollY = currentScrollY;
    };
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSharingOptions && !shareRef.current.contains(event.target)) {
        setShowSharingOptions(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSharingOptions]);

  useEffect(() => {
    if (timestampShareRef.current) {
      let width = timestampShareRef.current.offsetWidth;
      if (isMobile) {
        width += 3;
      }
      setTimestampShareWidth(`${width}px`);
    }
  }, [isMobile]);

  const sharingHandler = () => {
    setShowSharingOptions(!showSharingOptions);
  };

  const DhExlusiveDesktop = isDHExclusive && !isMobile;

  return (
    <div styleName="wrapper">
      {!isSponsoredStory && !isBrandspotNoAdStory && !isBrandspotClientStory && !DhExlusiveDesktop && (
        <div id="author-wrapper-id">
          <Authors
            authors={story.authors}
            clazzName="author-name-image"
            lastUpdatedDateAndTime={lastUpdatedDateAndTime}
          />
        </div>
      )}
      {isMobile && !tempHideAd ? (
        <div styleName="ad-wrapper mobile-top-ad" className="hide-desktop">
          <AdContainer
            storyPageAds={true}
            AdClassName="standard-336x280"
            id={adType === "izooto" ? "div-gpt-ad-1711971869798-0" : "div-gpt-ad-1750399308852-0"}
            mobile={adType === "izooto" ? "DH_MWeb_AT_Top_ym" : "DH_MWeb_AT_Top"}
            isExternalAdPath={adType === "izooto" ? true : false}
          />
        </div>
      ) : null}
      <div styleName={` ${isSticky ? "alternate-wrapper" : ""}`}></div>
      <div
        styleName={`timestamp-share-wrapper ${isDHExclusive ? "less-space" : ""}`}
        className={`sticky-div ${isSticky ? "sticky" : ""}`}
        ref={timestampShareRef}
        style={{ width: timestampShareWidth }}
        id="sticky-div-id"
      >
        <div styleName="author-resize-wrapper-contents">
          <FollowUs />
          <div styleName="comment-share-wrapper">
            {story["story-template"] !== "live-blog" && (
              <CommentsCount story={story} showCommentText={false} renderPortal={true} />
            )}
            <div styleName="share" ref={shareRef}>
              <button styleName="share-btn" onClick={sharingHandler}>
                <Share color="black" height="20px" width="20px" />
              </button>
              <div styleName="share-options">{showSharingOptions && <SocialMediaShare story={story} />}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

AuthorAndTimeStamp.propTypes = {
  story: object,
  isDHExclusive: bool,
  isSponsoredStory: bool,
  isBrandspotClientStory: bool,
  isBrandspotNoAdStory: bool
};

AuthorAndTimeStamp.defaultProps = {
  isDHExclusive: false,
  isSponsoredStory: false,
  isBrandspotClientStory: false,
  isBrandspotNoAdStory: false
};
export default AuthorAndTimeStamp;
